import Address from './Address.vue';
import User from './User.vue';
import Avatar from './Avatar.vue';

export default {
    Address,
    User,
    Avatar,
};



// WEBPACK FOOTER //
// ./src/components/UserInfo/index.js